var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 66,
    viewBox: "0 0 75 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 14.3242C64.8593 14.3242 68 11.1843 68 7.32422C68 3.46487 64.86 0.324219 61 0.324219C57.1407 0.324219 54 3.46418 54 7.32422C54.0007 11.1836 57.1405 14.3242 61 14.3242Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.3242C16.8593 14.3242 20 11.1843 20 7.32422C20 3.46487 16.86 0.324219 13 0.324219C9.14065 0.324219 6 3.46418 6 7.32422C6 11.1836 9.13996 14.3242 13 14.3242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9318 49.6889L70.4731 19.5532C70.3684 18.8468 69.7683 18.3242 69.0627 18.3242H54.0796C53.3767 18.3242 52.778 18.8428 52.6705 19.5459L48.017 49.9117C47.9527 50.3276 48.0727 50.7516 48.3439 51.071C48.6138 51.391 49.0103 51.5755 49.4261 51.5755H60.0653V63.8818C60.0653 64.6782 60.7039 65.3242 61.4909 65.3242C62.278 65.3242 62.9166 64.6782 62.9166 63.8818L62.9172 51.5748H73.5558C73.5631 51.5754 73.5697 51.5754 73.5744 51.5748C74.3628 51.5748 75 50.9287 75 50.1324C75 49.9774 74.9761 49.8278 74.9317 49.6883L74.9318 49.6889Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5209 17.3242H1.47968C1.04755 17.3242 0.637426 17.512 0.355975 17.8388C0.0752103 18.1656 -0.048649 18.5979 0.0174111 19.0234L4.84808 50.0338C4.95956 50.7525 5.58094 51.2814 6.31035 51.2814H12.52V63.8512C12.52 64.6644 13.182 65.3242 13.9995 65.3242C14.817 65.3242 15.4789 64.6644 15.4789 63.8512V51.2814H21.8565C22.5893 51.2814 23.2114 50.7484 23.3201 50.0256L27.9836 19.0152C28.0476 18.5911 27.9224 18.1608 27.6416 17.8353C27.3608 17.5113 26.9514 17.3242 26.5206 17.3242L26.5209 17.3242Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0.324219C36.6712 0.324219 36 0.972052 36 1.77208V63.8764C36 64.6757 36.6712 65.3242 37.5 65.3242C38.3281 65.3242 39 64.6757 39 63.8764V1.77208C39 0.972724 38.3281 0.324219 37.5 0.324219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrooms);
export default __webpack_public_path__ + "static/media/restrooms.b04cae0a41172f9f5a708a49754d1cde.svg";
export { ForwardRef as ReactComponent };